import Debt, { DebtToCreate, DebtToUpdate } from "../models/Debt";
import { Observable } from "rxjs";
import { HttpCommunicator, Container } from "@ivorobioff/shared";
import { SingleAmountUpdate } from '../models/Entry';


export class DebtService {

  private http: HttpCommunicator;

  constructor(container: Container) {
    this.http = container.get('https');
  }

  getAll(): Observable<Debt[]> {
    return this.http.get('/debts');
  }

  getAllAsync(): Promise<Debt[]> {
    return new Promise((resolve, reject) =>
      this.getAll().subscribe(resolve, reject));
  }

  updateAmount(id: string, update: SingleAmountUpdate): Observable<Debt> {
    return this.http.patch('/debts/' + id, update);
  }

  updateAmountAsync(id: string, update: SingleAmountUpdate): Promise<Debt> {
    return new Promise((resolve, reject) =>
      this.updateAmount(id, update).subscribe(resolve, reject));
  }

  update(id: string, updates: DebtToUpdate): Observable<Debt> {
    return this.http.patch('/debts/' + id, updates);
  }

  create(debt: DebtToCreate): Observable<Debt> {
    return this.http.post('/debts', debt);
  }

  createAsync(debt: DebtToCreate): Promise<Debt> {
    return new Promise((resolve, reject) =>
      this.create(debt).subscribe(resolve, reject));
  }

  remove(id: string): Observable<void> {
    return this.http.delete('/debts/' + id);
  }
}